import React from 'react'

function About() {
  return (
    <>
    <section className="ftco-about ftco-no-pb ftco-section" id="home-section">
    <div className="carouselOuter container">
        <div className="row">
          <div className="col-md-12 one-forth d-flex  align-items-center">
            <div className="text">
              <h1 className="mb-4 mt-3">
                Hello, I'm <span>Harjeevan Singh Tanda</span>
              </h1>
              <h2 className="mb-4">Full Stack Developer</h2>
            </div>
          </div>
      </div>
    </div>
    </section>
  <section className="ftco-about ftco-no-pb ftco-section" id="about-section">
    <div className="container">
      <div className="row d-flex">
        <div className="col-md-12">
          <div className="row justify-content-start pb-3">
            <div className="col-md-12 heading-section ">
              <h1 className="big">About</h1>
              <h2 className="mb-4">About Me</h2>
              <p>
                I'm a full-stack developer with {new Date().getFullYear() - 2014}+ years of experience building scalable web applications and APIs across the entire development lifecycle. On the frontend, I work with React.js and Next.js to build responsive, user-friendly interfaces. On the backend, I use Node.js, Python, and PHP (Express.js, CodeIgniter) to build RESTful APIs and manage databases. I've led teams and worked in agile environments, handling sprint planning and iterative delivery from concept to production.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </>
  )
}

export default About